<template>
  <div class="content">
    <v-header :activePage="'质量之声'"></v-header>

    <div class="main_carousel">
      <el-row type="flex">
        <el-row type="flex" justify="center" class="main_title">
        <h3>{{ $parseLabel('质量之声') }}</h3>

        </el-row>

      </el-row>

      <div class="main_module_select">
        <ul v-if="(false === isEmpty(moduleList)) && (moduleSelected !== undefined) && (moduleSelected.moduleId !== undefined)">
          <li v-for="moduleItem in moduleList" :key="moduleItem.moduleId" @click="handleModuleSelected(moduleItem)">
            <div :class="(moduleSelected.moduleId === moduleItem.moduleId) ? 'module_item active' : 'module_item'">
              
              <el-tooltip class="item" effect="dark" :content="$parseLabel(moduleItem.moduleName)" placement="top">
                <span>{{ $parseLabel(moduleItem.moduleName) }}</span>
              </el-tooltip>
            </div>
          </li>
        </ul>
      </div>

      <el-row class="main_voice_container">
        <div v-for="(subVoiceList, subVoiceIndex) in wrapperVoiceList" 
          :key="subVoiceIndex">

          <el-row type="flex" class="voice_row">
            <div class="voice_col" v-for="(voiceItem, index) in subVoiceList" :key="index">
              <div class="main_voice_item" @click="jump(voiceItem)">
                <el-row class="cover">
                  <img :src="voiceItem.cover" />
                </el-row>
                <el-row class="video-title">
                  <span class="two-line">
                    {{ voiceItem.title }}
                  </span>
                </el-row>
                <el-row type="flex" justify="space-between" class="video-info">
                  <el-col :span="12">
                    <span class="section_left" v-if="isEmpty(voiceItem.module) === false">{{ voiceItem.module }}</span>
                    <span class="section_left" v-else>版块名称</span>
                  </el-col>
                  <el-col :span="12">
                    <span class="time"><i class="el-icon-time mr5"></i>{{ voiceItem.releaseTime }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-row>
        </div>

        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :page-sizes="[10, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          ></el-pagination>
        </div>
      </el-row>

    </div>

    <v-footer></v-footer>
  </div>
</template>
        
<script>
import header from "@/components/header.vue";
import footer from "@/components/footer.vue";
import { getModuleList } from "@/api/kpi"
import { searchVoiceList } from "@/api/list";
import moment from "moment";

//一行显示数量
const ROW_NUM = 4

export default {
  components: {
    "v-header": header,
    "v-footer": footer,
    moment
  },
  data() {
    return {
      moduleList: [],
      moduleSelected: undefined,

      pageSize: 10,
      pageNum: 1,
      total: undefined,

      voiceList: [],
      wrapperVoiceList: [],
    };
  },
  created() {
    this.doGetModuleList();
  },
  methods: {
    jump(item) {
      console.log("jump item: ", item);
      sessionStorage.setItem("details", JSON.stringify(item));
      window.open('/#/details')
    },
    doGetModuleList(){
      let _this = this;
      _this.moduleList = [];
      getModuleList().then(res => {
        if ((res.success === true) && (_this.isEmpty(res.data) === false)) {

          _this.moduleList.push({
            moduleId: 0,
            moduleName: this.$parseLabel('全部')
          });

          res.data.forEach((moduleItem, index) => {
            _this.moduleList.push({
              moduleId: parseInt(moduleItem.id),
              moduleName: moduleItem.label
            });
          });

          _this.moduleList.forEach((moduleItem, index) => {
            if(index === 0) {
              _this.moduleSelected = moduleItem;
              this.doGetVoiceList();
            }
          });
        }
      }).catch(err=>{
        _this.msgError(err);
      });
    },
    handleModuleSelected(item) {
      this.moduleSelected = item;
      this.pageNum = 1;
      this.doGetVoiceList();
    },
    doGetVoiceList() {
      if((this.moduleSelected !== undefined) && (this.moduleSelected.moduleId !== undefined)) {
        searchVoiceList(this.moduleSelected, this.pageNum, this.pageSize).then((res) => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.releaseTime = moment(item.releaseDate).format("YYYY-MM-DD");
            });
            this.total = res.data.total;
            this.voiceList = res.data.list;

            this.wrapperVoiceList = [];
            let tempVoiceList = [];

            for (let index = 0; index <= this.voiceList.length / ROW_NUM; index += 1) {
              tempVoiceList = [];

              for(let tempIndex = 0; tempIndex < ROW_NUM; tempIndex++) {
                let realIndex = index * ROW_NUM + tempIndex;
                if(realIndex < this.voiceList.length) {
                  tempVoiceList[tempIndex] = this.voiceList[realIndex];
                }
              }
              if(tempVoiceList.length > 0) {
                this.wrapperVoiceList.push(tempVoiceList);
              }
            }
          }
        });
      }
    },
    handleSizeChange(item) {
      console.log("handleSizeChange item: ", item);
      this.pageNum = 1;
      this.pageSize = parseInt(item);
      this.doGetVoiceList();
    },
    handlePageChange(item){
      console.log("handlePageChange item: ", item);
      this.pageNum = parseInt(item);
      this.doGetVoiceList();
    }
  }
};
</script>

<style lang="less" scoped>
.main_title {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  height: 100px;
  line-height: 100px;

  h3 {
    position: relative;
    height: auto;
    line-height: auto;
    font-size: 46px;
    text-align: center;
  }

  h3::before {
    right: 100%;
    margin-right: 40px;
    background-image: url("~@/assets/img/arrow-left.png");
  }

  h3::after {
    left: 100%;
    margin-left: 40px;  
    background-image: url('~@/assets/img/arrow-right.png');
  }

  h3::before, h3::after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 84px;
    height: 16px;
    background-position: center;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
}

.main_carousel {
  min-width: 1500px;
  padding-top: 60px;
  padding-bottom: 60px;
  background-color: #FFFFFF;

  .module_right {
    width: 150px;
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    font-weight: bold;
    position: absolute;
    right: 0;
    display: flex;
    margin-right: 20px;

    .el-dropdown {
      height: 30px; 
      line-height: 30px;
      font-size: 14px;
      color: #000000;
      margin: auto;
      margin-right: 10px;
    }

    p {
      font-size: 14px;
      cursor: pointer;
    }
  }

  .main_module_select {
    width: 85%;
    margin: 20px auto 0 auto;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    ul {
      width: 100%;
      display: flex;
      margin-left: 20px;
      margin-right: 20px;
      list-style: none;
      box-sizing: content-box;
      justify-content: center;

      li {  
        width: auto;
        height: max-content;
        display: flex;
        box-sizing: border-box;

        .module_item {

          width: 100%;
          max-width: 400px;
          display: flex;
          box-sizing: border-box;
          padding: 0;
          margin: 0;
          outline: none;

          span {
            width: 100%;
            position: relative;
            color: #606266;
            padding: 10px 20px;
            font-size: 22px;
            font-weight: 400;
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
            //transition: all .5s ease-in;
            border-bottom: 1px solid #d2d7e0;
          }

          span:before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 1px;
            background-color: #d2d7e0;
            height: 10px;
          }
        }

        .active {
          box-sizing:border-box;

          span {
            color: var(--topMenuActiveTextColor);
            border-bottom: 2px solid var(--topMenuActiveTextColor);
          }
        }

        .module_item:hover {
          span {
            color: var(--topMenuActiveTextColor);
            transition: all .2s ease-in-out;
          }
        }
      }

      li:last-child {
        .module_item {
          
          span:after {
            content: "";
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            width: 1px;
            background-color: #d2d7e0;
            height: 10px;
          }
        }
      }

      li:nth-child(3), li:nth-child(4), li:nth-child(8) {
        width: 12%;
      }

      li:nth-child(9) {
        width: 14%;
      }

      li:nth-child(10) {
        width: 10%;
      }
    }
  }

  .main_voice_container {
    width: 85%;
    margin: 20px auto;
  }

  .voice_row {
    width: 100%;
    height: 410px; 

    .voice_col {
      width: 25%;
      height: 100%;
      display: flex;

      .main_voice_item {
        width: 100%;
        height: fit-content;
        margin: 10px 15px;
        background-color: transparent;
        border-radius: var(--commonBorderRadius);
        // box-shadow: var(--boxShadowLight);
        -webkit-transition: all .3s;
        transition: all .3s;

        .cover {
          width: 100%;
          height: 260px;
          border-radius: var(--commonBorderRadius);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: var(--commonBorderRadius);
          }
        }


        .video-title {
          width: 100%;
          padding: 16px 14px; 
          align-items: center;

          .single-line {
            display: inline-block;
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 14px; 
            color: #888888;
            font-weight: 300;
            white-space:nowrap; //禁止换行
            overflow: hidden; //隐藏多出部分文字
            text-overflow: ellipsis; //用省略号代替多出部分文字
          }

          .two-line {
            width: 100%;
            height: 40px;
            line-height: 20px;
            font-size: 18px; 
            font-weight: 700;
            color: #333333;
            display:-webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            overflow: hidden; //隐藏多出部分文字
            text-overflow: ellipsis; //用省略号代替多出部分文字
          }
        }

        .video-info {
          width: 100%;
          padding: 0px 14px 16px 14px;

          .section_left {
            height: 20px; 
            line-height: 20px;
            float: left;
            font-size: 14px; 
            color: #6b7484; 
            opacity: 1; 
            font-weight: 400;
          }

          .time {
            height: 20px; 
            line-height: 20px;
            float: right;
            font-size: 14px; 
            color: #888888;
            font-weight: 300;
          }
        }
      }

      .main_voice_item:hover {
        // box-shadow: var(--boxShadowDeep);
        transform: translateY(-8px);
        -webkit-transition: all .3s;
        transition: all .3s;

        .two-line {
          color: var(--commonHoverTextColor);
        }
      }
    }
  }
}
</style>